import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { DataService } from 'src/app/services/data.service';
import { TokenStorageService } from 'src/app/services/token-storage.service';

@Component({
  selector: 'app-delete-account',
  imports: [CommonModule, ReactiveFormsModule],
  templateUrl: './delete-account.component.html',
  styleUrl: './delete-account.component.scss'
})
export class DeleteAccountComponent {
  deleteForm!: FormGroup;
  isLoading = false;
  isDeleted = false;
  errorMessage: string | null = null;

  constructor(
    private fb: FormBuilder,
    private dataService: DataService,
    private tokenStorageService: TokenStorageService,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.deleteForm = this.fb.group({
      email: ['', [Validators.required, Validators.email]],
      password: ['', [Validators.required, Validators.minLength(6)]]
    });
  }

  onSubmit(): void {
    if (this.deleteForm.invalid) return;

    this.isLoading = true;
    this.errorMessage = null;

    const credentials = this.deleteForm.value; // bevat { email, password }

    this.dataService.deleteUser(credentials).subscribe({
      next: () => {
        this.isLoading = false;
        this.isDeleted = true;
        
        // Log de gebruiker lokaal uit als hij toevallig nog ingelogd was
        this.tokenStorageService.signOut();

        // Stuur na 3 seconden door naar de homepagina
        setTimeout(() => this.router.navigate(['/home']), 3000);
      },
      error: (err) => {
        this.isLoading = false;
        this.errorMessage = err?.error?.message || 'An error occured while deleting your account. Please try again.';
      }
    });
  }

}
